<hr>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="form-row">
            <div class="col-md-6 mb-2">
              <label for="bens">Filtro de Bens</label> 
              <ng-autocomplete 
              id="bens"
              [data]="bens"
              [searchKeyword]="keywordBens"
              (selected)='selectBem($event)'
              [itemTemplate]="itemTemplateBens"
              [notFoundTemplate]="notFoundTemplateBens">                                 
            </ng-autocomplete>
            
            <ng-template #itemTemplateBens let-item>
              <a [innerHTML]="item.dS_BPM_DESCRICAO_BEM"></a>
            </ng-template>
            
            <ng-template #notFoundTemplateBens let-notFound>
            <div [innerHTML]=""></div>
            </ng-template>
            </div>
            <!-- <div class="col-md-2 d-inline p-4">
              <button class="btn btn-outline-secondary mt-0" (click)="pesquisarBens()">
                <i class="fa fa-search"></i>
              </button>
            </div> -->
          </div>
          <!-- <div class="col-md-4">
            <label for="">Data inicio:</label>
            <div class="form-group">
              <input type="date" [ngModel]="inicio | date:'yyyy-MM-dd'" 
              (ngModelChange)="inicio = $event" name="dt"
                class="form-control form-control-rounded" #searchDate>
            </div>
            <label for="">Data fim:</label>
            <div class="form-group">
              <input type="date" [ngModel]="fim | date:'yyyy-MM-dd'" 
              (ngModelChange)="fim = $event" name="dt"
                class="form-control form-control-rounded" #searchDate>
            </div>
            <button class="btn btn-outline-secondary" 
            style="margin-top: 0; height: 40px" (click)="ativar()">
            <i class="bi bi-calendar-plus"></i>
            </button>
          </div>          -->
          <hr />
          <div class="table-responsive table-hover" style="overflow-y: hidden; overflow-x: auto">
            <table class="table" *ngIf="!loading">
              <thead class="">
                <tr>
                  <th>#</th>
                  <th>Data da movimentação</th>
                  <th>Tipo de Movimentação</th>
                  <th>Autor da movimentação</th>
                  <th class="text-right"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let mov of page.dados">     
                  <th>
                    {{mov.cD_BPM_MOVIMENTACAO_PATRIMONIAL}}  <span [ngClass]="{'open' : mov.cD_BPM_MOVIMENTACAO_PATRIMONIAL_FIM == 0 }"> - {{mov.cD_BPM_MOVIMENTACAO_PATRIMONIAL_FIM }}</span> 
                  </th>
                  <td>
                    {{ mov.dT_DATA_MOVIMENTACAO_PATRIMONIAL | date:'dd/MM/yyyy'}}
                  </td>
                  <td>
                    {{mov.dS_BPM_TIPO_MOVIMENTACAO_PATRIMONIAL}}
                  </td>
                  <td>
                    {{mov.dS_NM_AUTOR}}
                  </td>
                  <td class="actions text-center">
                    <a class="btn btn-icon btn-neutral btn-twitter" 
                    (click)="abreEdicao(mov.nR_BPM_BEM_PATRIMONIAL,
                    mov.cD_BPM_MOVIMENTACAO_PATRIMONIAL,mov.cD_BPM_MOVIMENTACAO_PATRIMONIAL_FIM)">
                      <i class="fa fa-edit"></i>
                    </a></td>
                </tr>
              </tbody>
            </table>
            <div class="row" *ngIf="page.dados && !loading">
              <div class="col-md-12">
                <ul class="pagination" *ngIf="page.pages.length > 0">
                  <li class="page-item" [ngClass]="{ disabled: page.currentPage === 1 }" title="Primeira página">
                    <a class="page-link" aria-label="Primeira página" (click)="setPage(1)">
                      <span aria-hidden="true"><i class="fa fa-angle-double-left" aria-hidden="true"></i></span>
                    </a>
                  </li>
                  <li class="page-item" title="Página anterior" [ngClass]="{ disabled: page.currentPage === 1 }">
                    <a class="page-link" aria-label="Página anterior" (click)="setPage(page.currentPage - 1)">
                      <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                    </a>
                  </li>
                  <li *ngFor="let page of page.pages" class=""
                    [ngClass]="{ 'page-item': true, active: paginaAtual(page)}" [attr.title]="'Página ' + page">
                    <a class="page-link" (click)="setPage(page)">{{ page }}</a>
                  </li>
                  <li class="page-item" title="Próxima página" [ngClass]="{
                  disabled: page.currentPage === page.totalPages
                }">
                    <a class="page-link" aria-label="Próxima página" (click)="setPage(page.currentPage + 1)">
                      <span aria-hidden="true"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
                    </a>
                  </li>
                  <li class="page-item" title="Última página"
                  [ngClass]="{ disabled: page.currentPage === page.totalPages }">
                    <a class="page-link" aria-label="Última página" (click)="setPage(page.totalPages)">
                      <span aria-hidden="true"><i class="fa fa-angle-double-right" aria-hidden="true"></i></span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center" *ngIf="loading">
                <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center" *ngIf="page.dados?.length == 0 && !loading">
                <h5>Não há dados para exibir</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>